export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
